import * as moment from "moment";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";

const EMPTY_STRING = "";
const NULL_VALUE = null;

export class GridUtils {
  static _buildAdvancedFilterExpression(
    operands?: any,
    operator?: any,
    operand?: any
  ): string {
    let filterExpression = EMPTY_STRING;

    //Chart Date must be refactored
    if (operand) {
      const value = operand.searchVal;
      let filterValue;
      const fieldName = operand.fieldName;
      let filterString;
      if (value instanceof Date) {
        filterValue = moment(value).format("YYYY-MM-DD HH:mm:ss").toString();
        filterValue = `'${filterValue}'`;
      }
      switch (operand?.condition?.name) {
        case "before": {
          filterString = `${fieldName} ${FilterOperation.BEFORE} ${filterValue}`;
          // filterString = `${fieldName} ${FILTER_OPERATION.CONTAINS} ${Array.from(value.values())}`;
          break;
        }
        case "after": {
          filterString = `${fieldName} ${FilterOperation.AFTER} ${filterValue}`;
          // filterString = `${fieldName} ${FILTER_OPERATION.CONTAINS} ${Array.from(value.values())}`;
          break;
        }
      }
      filterExpression += filterString;
    } else {
      operands.forEach((operand) => {
        const value = operand.searchVal;
        const isNumberValue = typeof value === "number" ? true : false;
        let filterValue;
        const fieldName = operand.fieldName;
        let filterString;

        if (value instanceof Date) {
          filterValue = moment(value).format("YYYY-MM-DD HH:mm:ss").toString();
          filterValue = `'${filterValue}'`;
        } else {
          filterValue = isNumberValue ? value : `'${value}'`;
        }

        switch (operand.condition.name) {
          case "contains": {
            if (Array.isArray(value)) {
              filterString = `${fieldName} ${
                FilterOperation.CONTAINS
              } ${this.buildStringArrayContains(Array.from(value.values()))}`;
            } else {
              filterString = `${fieldName} ${FilterOperation.CONTAINS} %${value}%`;
            }
            break;
          }
          case "startsWith": {
            if (Array.isArray(value)) {
              filterString = `${fieldName} ${
                FilterOperation.CONTAINS
              } ${this.buildStringArray(Array.from(value.values()))}`;
            } else {
              filterString = `${fieldName} ${FilterOperation.CONTAINS} ${value}%`;
            }
            break;
          }
          case "endsWith": {
            if (Array.isArray(value)) {
              filterString = `${fieldName} ${
                FilterOperation.CONTAINS
              } ${this.buildStringArray(Array.from(value.values()))}`;
            } else {
              filterString = `${fieldName} ${FilterOperation.CONTAINS} %${value}`;
            }
            break;
          }
          case "equals": {
            filterString = `${fieldName} ${FilterOperation.EQUALS} ${filterValue} `;
            break;
          }
          case "doesNotEqual": {
            if (Array.isArray(value)) {
              filterString = `${fieldName} ${
                FilterOperation.DOES_NOT_EQUAL
              } ${this.buildStringArray(Array.from(value.values()))}`;
            } else {
              filterString = `${fieldName} ${FilterOperation.DOES_NOT_EQUAL} '${value}'`;
            }
            break;
          }
          case "doesNotContain": {
            if (Array.isArray(value)) {
              filterString = `${fieldName} ${
                FilterOperation.DOES_NOT_EQUAL
              } ${this.buildStringArray(Array.from(value.values()))}`;
            } else {
              filterString = `${fieldName} ${FilterOperation.DOES_NOT_EQUAL} '${value}'`;
            }
            break;
          }
          case "greaterThan": {
            filterString = `${fieldName} ${FilterOperation.GREATER_THAN} ${filterValue} `;
            break;
          }
          case "greaterThanOrEqualTo": {
            filterString = `${fieldName} ${FilterOperation.GREATER_THAN_EQUAL} ${filterValue} `;
            break;
          }
          case "lessThan": {
            filterString = `${fieldName} ${FilterOperation.LESS_THAN} ${filterValue} `;
            break;
          }
          case "lessThanOrEqualTo": {
            filterString = `${fieldName} ${FilterOperation.LESS_THAN_EQUAL} ${filterValue} `;
            break;
          }
          case "empty": {
            filterString = `${fieldName} ${FilterOperation.EQUALS} ' '`;
            break;
          }
          case "notEmpty": {
            filterString = `${fieldName} ${FilterOperation.NOT_EQUAL} ' '`;
            break;
          }
          case "null": {
            filterString = `${fieldName} ${FilterOperation.EQUALS} ${NULL_VALUE}`;
            break;
          }
          case "notNull": {
            filterString = `${fieldName} ${FilterOperation.DOES_NOT_EQUAL} ${NULL_VALUE}`;
            break;
          }
          case "in": {
            filterString = `${fieldName} ${
              FilterOperation.IN
            } ${this.buildStringArray(Array.from(value.values()))}`;
            // filterString = `${fieldName} ${FILTER_OPERATION.CONTAINS} ${Array.from(value.values())}`;
            break;
          }
          case "true": {
            filterString = `${fieldName} ${FilterOperation.EQUALS} 'true'`;
            // filterString = `${fieldName} ${FILTER_OPERATION.CONTAINS} ${Array.from(value.values())}`;
            break;
          }
          case "false": {
            filterString = `${fieldName} ${FilterOperation.EQUALS} 'false'`;
            // filterString = `${fieldName} ${FILTER_OPERATION.CONTAINS} ${Array.from(value.values())}`;
            break;
          }
          case "before": {
            filterString = `${fieldName} ${FilterOperation.BEFORE} ${filterValue}`;
            // filterString = `${fieldName} ${FILTER_OPERATION.CONTAINS} ${Array.from(value.values())}`;
            break;
          }
          case "after": {
            filterString = `${fieldName} ${FilterOperation.AFTER} ${filterValue}`;
            // filterString = `${fieldName} ${FILTER_OPERATION.CONTAINS} ${Array.from(value.values())}`;
            break;
          }
          default: {
            // alerta option not available for the moment
            filterString = "";
            break;
          }
        }

        filterExpression += filterString;
      });
    }

    return filterExpression;
  }

  static buildStringArray(values: any[]): string {
    let result = "";
    if (values.length > 0) {
      values.forEach((value, idx) => {
        if (idx === 0) {
          result +=
            "(" +
            ((typeof value === "number" ? true : false) ? value : `'${value}'`);
        } else {
          result +=
            "," +
            ((typeof value === "number" ? true : false) ? value : `'${value}'`);
        }
      });
      result += ")";
    }

    return result;
  }

  static buildStringArrayContains(values: any[]): string {
    let result = "";
    if (values.length > 0) {
      values.forEach((value, idx) => {
        if (idx === 0) {
          result +=
            "(" +
            ((typeof value === "number" ? true : false)
              ? value
              : `'%${value}%'`);
        } else {
          result +=
            "," +
            ((typeof value === "number" ? true : false)
              ? value
              : `'%${value}%'`);
        }
      });
      result += ")";
    }

    return result;
  }

  static _buildSortExpression(sortingArgs): string {
    let sortingDirection: string;

    return `${sortingArgs.fieldName},${sortingDirection.toUpperCase()}`;
  }

  static _buildScrollExpression(pagingArgs): string {
    const skip = pagingArgs.skip;
    const top = pagingArgs.top;
    if (top && top !== null) {
      return `real_size=true&offset=${skip}&limit=${top}`;
    } else {
      return `real_size=true&offset=${skip}`;
    }
  }

  static _buildFilteringExpression(
    filteringArgs: any,
    container?: Map<string, string>
  ): string {
    let filter = EMPTY_STRING;

    if (filteringArgs && filteringArgs.length > 0) {
      //Chart Date must be refactored
      const chartDatesFilters = filteringArgs.filter((chartDate) => {
        if (chartDate && chartDate?.type === "chartDate") {
          return true;
        } else {
          return false;
        }
      });

      // filter global
      const globalFilters = filteringArgs.filter((global) => {
        if (global?.filteringOperands?.length > 0) {
          if (
            global?.filteringOperands[0] &&
            global?.filteringOperands[0]?.type === "globalFilter"
          ) {
            return true;
          } else {
            return false;
          }
        }
      });

      // filter date
      const dateFilters = filteringArgs.filter((date) => {
        if (date?.filteringOperands?.length > 0) {
          if (
            date?.filteringOperands[0] &&
            date?.filteringOperands[0]?.type === "dateFilter"
          ) {
            return true;
          } else {
            return false;
          }
        }
      });

      // filter grids
      const gridFilters = filteringArgs.filter((grid) => {
        if (grid?.filteringOperands?.length > 0) {
          if (
            grid?.filteringOperands[0] &&
            grid?.filteringOperands[0]?.type === undefined
          ) {
            return true;
          } else {
            return false;
          }
        }
      });

      if (gridFilters && gridFilters?.length > 0) {
        filter += "( " + this.filterProcess(gridFilters) + ") ";
      }

      if (globalFilters && globalFilters?.length > 0) {
        if (filter?.length > 0) {
          filter += " and ( " + this.filterProcess(globalFilters) + ") ";
        } else {
          filter += "( " + this.filterProcess(globalFilters) + ") ";
        }
      }
      if (dateFilters && dateFilters?.length > 0) {
        if (filter?.length > 0) {
          filter += " and ( " + this.filterProcess(dateFilters) + ")";
        } else {
          filter += "( " + this.filterProcess(dateFilters) + ")";
        }
      }
      //CHartDates must be refactored
      if (chartDatesFilters && chartDatesFilters?.length > 0) {
        if (filter?.length > 0) {
          filter += " and ( " + this.filterProcess(dateFilters) + ")";
        } else {
          filter += "( " + this.filterProcess(chartDatesFilters) + ")";
        }
      }
    }
    // filter's custom
    if (container && container?.size > 0) {
      container.forEach((value, key) => {
        const test = this.hasWhiteSpace(value);
        if (value?.length > 0) {
          if (filter.length > 0) {
            if (this.hasWhiteSpace(value)) {
              filter += "&& " + key + " == " + `"${value}"`;
            } else {
              filter += "&& " + key + " == " + value;
            }
          } else {
            if (this.hasWhiteSpace(value)) {
              filter += key + " == " + `"${value}"`;
            } else {
              filter += key + " == " + value;
            }
          }
        }
      });
    }

    return filter;
  }

  static filterProcess(filteringArgs: any): string {
    let filter = "";
    filteringArgs.forEach((columnFilter) => {
      let currentFilterArgs: any;
      if (columnFilter?.condition === undefined) {
        if (columnFilter?.filteringOperands[0]?.condition === undefined) {
          currentFilterArgs = columnFilter?.filteringOperands[0];
        } else {
          currentFilterArgs = columnFilter;
        }
      } else {
        currentFilterArgs = columnFilter;
      }

      if (currentFilterArgs?.filteringOperands) {
        filter += GridUtils._buildAdvancedFilterExpression(
          currentFilterArgs?.filteringOperands,
          currentFilterArgs?.operator
        );
      } else {
        // Chart dates
        filter += GridUtils._buildAdvancedFilterExpression(
          [],
          undefined,
          currentFilterArgs
        );
      }

      filter += " )";
    });
    return filter;
  }

  static isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
  }

  static hasWhiteSpace(s) {
    return s.indexOf(" ") >= 0;
  }
}
